export default class RouteOfAdministration {
	name: string;

	constructor(name: string) {
		this.name = name;
	}
}
